module.exports = __webpack_public_path__ + "img/zoomov.13ab2875.png";